import { useEffect, useState, useCallback } from "react";
import axios from "axios";
import { Gauge } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/**
 * Kompakte Anzeige der heutigen Pflege-KI-Nutzung pro Modul.
 * Wird im Pflege-KI-Header eingebunden. Zeigt Modul-Chips mit Used/Limit.
 */
export default function PkiUsageBadge({ refreshKey }) {
  const [data, setData] = useState(null);

  const load = useCallback(async () => {
    try {
      const r = await axios.get(`${API}/pflege-ki/ratelimit/me`, { withCredentials: true });
      setData(r.data);
    } catch {
      setData(null);
    }
  }, []);

  useEffect(() => { load(); }, [load, refreshKey]);

  if (!data) return null;

  return (
    <div data-testid="pki-usage-badge"
      className="rounded-2xl border border-cream-300 bg-cream-50 px-4 py-3">
      <div className="flex items-center justify-between mb-2 flex-wrap gap-2">
        <div className="flex items-center gap-2">
          <Gauge className="h-4 w-4 text-clay-dark" strokeWidth={2} />
          <div className="text-[10.5px] uppercase tracking-[0.28em] font-bold text-clay-dark">
            Tagesnutzung · {data.daily_limit}/Modul
          </div>
        </div>
        {data.is_admin_override && (
          <span className="inline-flex h-5 px-2 items-center rounded-full bg-saffron text-clay-dark text-[10px] uppercase tracking-[0.18em] font-bold">
            Admin-Limit aktiv
          </span>
        )}
      </div>
      <div className="flex flex-wrap gap-1.5">
        {data.modules.map((m) => {
          const pct = Math.round((m.used / Math.max(1, m.limit)) * 100);
          const tone = m.reached
            ? "bg-brand-darkred text-cream-50"
            : pct >= 80
              ? "bg-saffron text-clay-dark"
              : "bg-white text-sand-700 border border-cream-300";
          return (
            <span key={m.key}
              data-testid={`pki-usage-${m.key}`}
              className={`inline-flex items-center gap-1.5 px-2.5 h-7 rounded-full text-[11.5px] font-semibold ${tone}`}>
              <span className="opacity-80">{m.label}</span>
              <span className="font-mono">{m.used}/{m.limit}</span>
            </span>
          );
        })}
      </div>
    </div>
  );
}
